import { Col, Row } from "reactstrap";
import _ from "lodash";
import FormField from "../ui/Form/FormField";
import { arrayMap } from "./array.utils";

export function RenderFields({
  fields = [],
  control,
  watch,
  errors = {},
  setValue,
  setError,
  clearErrors,
  unregister
}) {
  return (
    <Row>
      {arrayMap(fields, (field) => (
        <Col key={field?.name} {...(field?.col ? field.col : { md: 2 })}>
          <FormField
            label={field?.label}
            id={field?.id}
            type={field?.type}
            name={field?.name}
            placeholder={field?.placeholder}
            options={field?.options}
            rules={field?.rules}
            control={control}
            errors={errors}
            setValue={setValue}
            setError={setError}
            clearErrors={clearErrors}
            watch={watch}
            unregister={unregister}
            customComponent={field?.customComponent}
            minDate={field?.minDate}
            selected={field?.selected}
            isDisabled={field?.isDisabled}
            isMulti={field?.isMulti}
            isClearable={typeof field?.isClearable === "boolean" ? field?.isClearable : true}
            others={field?.others} // only for custom component to pass values
            helpText={field?.helpText}
          />
        </Col>
      ))}
    </Row>
  );
}

export function optionGen(data, label = "name", value = "id") {
  return arrayMap(data, (item) => ({ label: item[label], value: item[value] })) || [];
}

export function getErrorMessage(data, name) {
  const cleanedInput = name?.replace(/\[|\]/g, "");
  const pathParts = cleanedInput?.split(".");
  const path = pathParts?.join(".");
  const value = path ? _.get(data, path) : undefined;
  return value;
}
